import { useState } from "react";
import { eDate, sDate } from "../../apollo";
import refresh from "../../assets/icon/refresh.png";
import { ko } from "date-fns/esm/locale";
import searchdate from "../../assets/icon/searchdate.png";
import exit from "../../assets/icon/exit.png";
import excel from "../../assets/icon/excel.png";
import { endheaders } from "../../constants/datas";
import { useEditOrdersStatus } from "../../hooks/useEditOrdersStatus";
import { Modal } from "@mui/material";
import React from "react";
import { IDateSearchFormProps } from "./component-tab-order";
import { useForm } from "react-hook-form";
import {
  OrderStatus,
  EditOrdersStatusInput,
  EditOrdersStatusMutation,
} from "../../generated/graphql";
import { CSVLink } from "react-csv";
import moment from "moment";

export interface ComponentTabEnd {
  dataList?: any[];
  DataCallback?: () => void;
  refetch?(): void;
  setDateSearch?: (sDate?: Date, eDate?: Date) => void;
}

export const ComponentTabEnd: React.FC<ComponentTabEnd> = ({
  dataList = [],
  DataCallback,
  setDateSearch,
  refetch,
}) => {
  const { register, getValues, handleSubmit } = useForm<IDateSearchFormProps>({
    mode: "all",
  });
  console.log(dataList);

  const datalist = dataList.map((row) => ({
    ...row,
    phone: `=""${row.receipt.phone}""`,
    createdAt: moment(row.createdAt).format("YYYY-MM-DD HH:mm"),
    endDate: moment(row.EndDate).format("YYYY-MM-DD HH:mm"),
    corporation: row.good.corporations?.map((a: any) => a.name),
  }));

  const [open, setOpen] = React.useState(false);
  const [change, setChange] = React.useState<OrderStatus>(
    OrderStatus.Delivered
  );
  const dateHandler = (date: Date) => {
    sDate(date);
  };
  const edateHandler = (date: Date) => {
    eDate(date);
  };
  const refetchHandler = () => {
    window.location.href = "/order/end";
  };
  const onSubmit = () => {
    const { sDate, eDate } = getValues();
    if (setDateSearch) {
      setDateSearch(sDate, eDate);
    }
  };

  // --- 상태 변경 한번에 ---
  const onEditCompleted = async (data: EditOrdersStatusMutation) => {
    const {
      editOrdersStatus: { ok, err },
    } = data;
    if (ok && refetch) {
      await refetch();
    } else {
      alert(err);
    }
  };
  const [editOrdersStatus, { loading }] = useEditOrdersStatus(onEditCompleted);
  const editOrdersStatusHandler = (status: OrderStatus) => {
    var orderIds: number[] = [];
    for (const data of dataList) {
      if (data.id) {
        orderIds.push(Number(data.id));
      }
    }
    if (!loading) {
      const editOrdersStatusInput: EditOrdersStatusInput = {
        orderIds,
        status,
      };
      editOrdersStatus({ variables: { input: editOrdersStatusInput } });
    }
  };

  return (
    <div className="flex flex-wrap justify-between">
      <div className="flex flex-wrap">
        <button
          className="py-3 px-4 relative"
          onClick={() => {
            refetchHandler();
          }}
        >
          <img src={refresh} alt="새로고침" className="w-[30px] h-[30px]" />
        </button>
        <button
          onClick={() => {
            setOpen(true);
          }}
          className="bg-[#555B94] w-[104px] h-[30px] py-[7px] text-xs text-center rounded-lg my-[13px] text-white"
        >
          상태변경
        </button>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap gap-x-4 content-center">
          <p className="text-[#8B8C8C] text-sm flex flex-wrap content-center">
            기간
          </p>
          <div className="flex flex-wrap content-center">
            <input
              {...register("sDate")}
              type="date"
              className="border w-full  border-[#F0F0F4] text-base rounded-lg py-1 px-4"
            ></input>
          </div>
          <span className="text-white flex flex-wrap content-center">~</span>
          <div className="flex flex-wrap content-center">
            <input
              {...register("eDate")}
              type="date"
              className="border w-full  border-[#F0F0F4] text-base rounded-lg py-1 px-4"
            ></input>
          </div>

          <button className="py-3">
            <img src={searchdate} alt="찾기" className="w-[32px] h-[30px]" />
          </button>
        </div>
      </form>
      <div className="flex flex-wrap justify-end pr-8">
        <div className="flex flex-wrap gap-x-3">
          <CSVLink
            data={datalist}
            headers={endheaders}
            filename={`주문내역`}
            className={`flex flex-wrap gap-x-1  w-[72px] h-[30px] my-[13px] bg-white text-center items-center rounded-lg`}
          >
            <p className="pl-[15px] text-xs text-[#8B8C8C]">csv</p>
            <img src={excel} className="w-[10px] h-3" />
          </CSVLink>
        </div>
      </div>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="max-w-[360px] w-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2   bg-[#F9F8F9] rounded-lg">
          <div className="text-center py-2 h-10 text-white font-bold bg-[#3D3E49] rounded-t-lg  ">
            <div className="flex flex-wrap justify-between">
              <p className="w-[240px] ml-[40px] font-bold text-base">
                배송 상태변경
              </p>
              <img
                src={exit}
                alt="닫기"
                className="w-6 mr-2 cursor-pointer"
                onClick={() => setOpen(false)}
              ></img>
            </div>
          </div>
          <div className="flex flex-wrap content-center">
            <div className="px-10 py-10">
              <div className="grid grid-rows-6 gap-y-4">
                <p className="font-bold">배송 준비</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="pending"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Pending);
                      }
                    }}
                  ></input>
                  <span className="ml-4">배송 준비</span>
                </div>
                <p className="font-bold">배송중</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Drone"
                    value="Drone"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Drone);
                      }
                    }}
                  ></input>
                  <span className="ml-4">드론 비행</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Port"
                    value="HandOut"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Port);
                      }
                    }}
                  ></input>
                  <span className="ml-4">최종 배송준비</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Stored"
                    value="Stored"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Stored);
                      }
                    }}
                  ></input>
                  <span className="ml-4">픽업포트</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="PendingDelivered"
                    value="PendingDeliverd"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.PendingDelivered);
                      }
                    }}
                  ></input>
                  <span className="ml-4">최종 배송</span>
                </div>
                <p className="font-bold">배송 완료</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="check"
                    value="Delivered"
                    checked={change === OrderStatus.Delivered}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Delivered);
                      }
                    }}
                  ></input>
                  <span className="ml-4">배송 완료</span>
                </div>
                <p className="font-bold">환불/교환</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="confirm"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Refunded);
                      }
                    }}
                  ></input>
                  <span className="ml-4">환불</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="end"
                    value="Exchange"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Exchange);
                      }
                    }}
                  ></input>
                  <span className="ml-4">교환</span>
                </div>
                <p className="font-bold">확정</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Complete"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Complete);
                      }
                    }}
                  ></input>
                  <span className="ml-4">확정</span>
                </div>
              </div>
            </div>
          </div>
          <button
            className="w-full h-14 bg-[#F0F0F4] rounded-b-lg"
            onClick={() => {
              editOrdersStatusHandler(change);
              setOpen(false);
            }}
          >
            확인
          </button>
        </div>
      </Modal>
    </div>
  );
};
